import { render, staticRenderFns } from "./dialog-admin-mydrive.vue?vue&type=template&id=5bcfe96d&"
import script from "./dialog-admin-mydrive.vue?vue&type=script&lang=js&"
export * from "./dialog-admin-mydrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports